/** Created by azhou on 2019/3/25.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">
      <span class="text-link" @click="$emit('goStoreDetail',item.id)">{{item.title || item.travelName}}</span>
    </li>
    <li class="w-50 list-item-col">{{item.score || item.exp || 0}}</li>
    <li class="w-50 list-item-col" v-if="storeInfo.type!==2">{{item.exp_level}}</li>
    <li class="w-50 list-item-col" v-if="storeInfo.type!==2">
      <img :src="item.exp_icon ? '/images/grade/'+ item.exp_icon : ''">
    </li>
    <li class="w-50 list-item-col-end">
      <span class="text-link" @click="$emit('goDetailList','2',item.id)">查看明细</span>
    </li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreditList',
    props:{
      item:{}
    },
    computed:{
      ...mapGetters(['storeInfo']),
    }
  }
</script>
